import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const getFirmwares = createAsyncThunk('get/firmwares', async (params) => {
  const response = await axios.get('/list_firmware', { params });
  return response.data;
});

export const uploadFirmware = createAsyncThunk(
  'post/uploadFirmware',
  async (firmwareData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/upload_firmware', firmwareData);
      dispatch(getFirmwares());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateFirmware = createAsyncThunk('post/updateFirmware', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post(`/update_firmware/`, data);
    dispatch(getFirmwares());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteFirmware = createAsyncThunk(
  'delete/deleteFirmware',
  async (firmwareID, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/delete_firmware/${firmwareID}`);
      dispatch(getFirmwares());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendCommand = createAsyncThunk(
  'post/sendCommaand',
  async ({ serialNumber, command }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`/add_command/${serialNumber}/${command}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const stopAdminMode = createAsyncThunk('get/stopAdminMode', async (chargerID, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.get(`/stop_admin_mode/${chargerID}`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const startAdminMode = createAsyncThunk(
  'get/startAdminMode',
  async (chargerID, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`/start_admin_mode/${chargerID}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateNetwork = createAsyncThunk(
  'post/updateNetwork',
  async (networkData, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/update_network', networkData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTaxes = createAsyncThunk('get/taxes', async () => {
  const response = await axios.get('/taxe-regime/');
  return response.data;
});

export const getTaxById = createAsyncThunk('get/taxById', async (taxID) => {
  const response = await axios.get(`/taxe-regime/${taxID}`);
  return response.data;
});

export const deleteManyTaxes = createAsyncThunk(
  'delete/deleteManyTaxes',
  async (ids, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/taxe-regime/delete_many/', { ids });
      dispatch(getTaxes());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteManyRFIds = createAsyncThunk(
  'delete/deleteManyRFIds',
  async (ids, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/rfid-tag/delete_many/', { ids });
      dispatch(getRfidTags());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addTax = createAsyncThunk('post/addTax', async (taxesData, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/taxe-regime/', taxesData);
    dispatch(getTaxes());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateTax = createAsyncThunk(
  'post/updateTax',
  async ({ taxID, taxData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/taxe-regime/${taxID}/`, taxData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteTax = createAsyncThunk('delete/deleteTax', async (taxID, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/taxe-regime/${taxID}`);
    dispatch(getTaxes());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getRfidTags = createAsyncThunk('get/rfidTags', async () => {
  const response = await axios.get('/rfid-tag/');
  return response.data;
});

export const getRfidTagById = createAsyncThunk('get/rfidTagById', async (rfidTagID) => {
  const response = await axios.get(`/rfid-tag/${rfidTagID}`);
  return response.data;
});

export const addRfidTag = createAsyncThunk('post/addRfidTag', async (rfidTagData, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/rfid-tag/', rfidTagData);
    dispatch(getRfidTags());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateRfidTag = createAsyncThunk(
  'put/updateRfidTag',
  async ({ rfidTagID, rfidTagData }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/rfid-tag/${rfidTagID}/`, rfidTagData);
      dispatch(getRfidTags());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteRfidTag = createAsyncThunk(
  'delete/deleteRfidTag',
  async (rfidTagID, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/rfid-tag/${rfidTagID}`);
      dispatch(getRfidTags());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const associateToUser = createAsyncThunk('post/associateToUser', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/rfid-tag/associate_to_user/', data);
    dispatch(getRfidTags());
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const removeFromUser = createAsyncThunk('post/removeFromUser', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete('/rfid-tag/remove_from_user/', { data: data });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const settingsSlice = createSlice({
  name: 'setting',
  initialState: {
    firmwares: [],
    firmwareById: '',
    loading: false,
    taxes: [],
    buttonEnabled: false,
    taxById: '',
    rfidTags: [],
    rfidTagById: '',
    isSubmitting: false,
  },
  reducers: {
    enableButton: (state, action) => {
      state.buttonEnabled = action.payload;
    },
  },
  extraReducers: {
    [uploadFirmware.pending]: (state) => {
      state.isSubmitting = true;
    },
    [uploadFirmware.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [uploadFirmware.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [updateFirmware.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateFirmware.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateFirmware.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [deleteFirmware.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteFirmware.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteFirmware.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [updateNetwork.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateNetwork.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateNetwork.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [getFirmwares.pending]: (state) => {
      state.loading = true;
    },
    [getFirmwares.fulfilled]: (state, action) => {
      state.firmwares = action.payload.data;
      state.loading = false;
    },
    [getFirmwares.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------
    [getTaxes.pending]: (state) => {
      state.loading = true;
    },
    [getTaxes.fulfilled]: (state, action) => {
      state.taxes = action.payload.data;
      state.loading = false;
    },
    [getTaxes.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------
    [getTaxById.pending]: (state) => {
      state.loading = true;
    },
    [getTaxById.fulfilled]: (state, action) => {
      state.taxById = action.payload.data;
      state.loading = false;
    },
    [getTaxById.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------
    [addTax.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addTax.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addTax.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [updateTax.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateTax.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateTax.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [deleteTax.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteTax.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteTax.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [deleteManyTaxes.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyTaxes.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyTaxes.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [getRfidTags.pending]: (state) => {
      state.loading = true;
    },
    [getRfidTags.fulfilled]: (state, action) => {
      state.rfidTags = action.payload.data;
      state.loading = false;
    },
    [getRfidTags.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------
    [getRfidTagById.pending]: (state) => {
      state.loading = true;
    },
    [getRfidTagById.fulfilled]: (state, action) => {
      state.rfidTagById = action.payload.data;
      state.loading = false;
    },
    [getRfidTagById.rejected]: (state) => {
      state.loading = false;
    },
    // -------------------------------------------
    [addRfidTag.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addRfidTag.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addRfidTag.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [updateRfidTag.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateRfidTag.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateRfidTag.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [deleteRfidTag.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteRfidTag.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteRfidTag.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------Send commands operations------------------------------
    [sendCommand.pending]: (state) => {
      state.isSubmitting = true;
    },
    [sendCommand.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [sendCommand.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [startAdminMode.pending]: (state) => {
      state.isSubmitting = true;
    },
    [startAdminMode.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [startAdminMode.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [stopAdminMode.pending]: (state) => {
      state.isSubmitting = true;
    },
    [stopAdminMode.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [stopAdminMode.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -------------------------------------------
    [associateToUser.pending]: (state) => {
      state.isSubmitting = true;
    },
    [associateToUser.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [associateToUser.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------
    [removeFromUser.pending]: (state) => {
      state.loading = true;
    },
    [removeFromUser.fulfilled]: (state) => {
      state.loading = false;
    },
    [removeFromUser.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------
  },
});

export const { enableButton } = settingsSlice.actions;

export default settingsSlice.reducer;
